import findIndex from 'lodash/findIndex';
import toLower from 'lodash/toLower';
import { LandingServiceModule } from 'services/data/landing.service';
import { LaunchDarklyServiceModule } from 'services/access/launchDarkly/launchDarkly.service';
import { StoreInformationServiceModule } from 'services/data/storeInformation.service';
import { NAV_STATES } from '../navigationMenu.constants';

export const NavigationMenuServiceModule = angular
    .module('app.services.utilities.navigationMenuService', [
        LandingServiceModule,
        LaunchDarklyServiceModule,
        StoreInformationServiceModule
    ]).service('navigationMenuService', (
        $mdSidenav,
        $window,
        launchDarklyService,
        storeInformationService,
        DEFAULT_APPS
    ) => {
        const appOrder = [
            NAV_STATES.ORDERS,
            NAV_STATES.PRODUCTS,
            NAV_STATES.DISCOUNTS,
            NAV_STATES.CATEGORIES,
            NAV_STATES.CUSTOMERS,
            NAV_STATES.APP_STORE,
            NAV_STATES.SETTINGS,
            NAV_STATES.ANALYTICS,
            NAV_STATES.SITE_DESIGNER,
            NAV_STATES.PAGES,
            NAV_STATES.SITE_TAGGING,
            NAV_STATES.EDIT_MENU
        ];
        const defaultIconColor = '#221b43';
        const homeApp = {
            type: NAV_STATES.DASHBOARD,
            icon: 'home',
            link: NAV_STATES.DASHBOARD,
            label: 'LABEL.HOME',
            color: defaultIconColor
        };

        const siteTaggingApp = {
            type: 'siteTagging',
            icon: 'code',
            link: 'siteTagging',
            label: 'LABEL.SITE_TAGGING',
            color: defaultIconColor,
            linkedApp: true
        };

        const usersAndPermissionsApp = {
            type: 'users',
            icon: 'people_alt',
            link: 'usersAndPermissions',
            label: 'LABEL.USER_PERMISSIONS',
            color: defaultIconColor
        };

        const blockManagementApp = {
            type: 'blocks',
            icon: 'widgets',
            link: 'blockManagement',
            label: 'LABEL.BLOCK_MANAGEMENT',
            color: defaultIconColor
        };

        const menuManagementApp = {
            type: 'menuManagement',
            label: 'LABEL.MENU_MANAGEMENT',
            icon: 'menu',
            link: 'menuManagement',
            color: defaultIconColor,
            linkedAppEnd: true
        };

        const storeCreditApp = {
            type: 'storeCredit',
            icon: 'card_giftcard',
            link: 'storeCredit',
            label: 'LABEL.STORECREDIT',
            color: defaultIconColor
        };

        const discountsApp = {
            type: 'discounts',
            icon: 'event_seat',
            href: `${process.env.NEW_ADMIN_BASE_URI}/discounts/all`,
            label: 'LABEL.DISCOUNTS',
            color: defaultIconColor
        };

        return {
            toggle,
            close,
            getSelectedAppType,
            loadApps,
            removeNavOpenCssClassFromBody,
            addNavOpenCssClassFromBody,
            setNavMenuMarginOnElements,
            appOrder,
            homeApp
        };

        function toggle() {
            $mdSidenav('nav-menu').toggle();
            if ($mdSidenav('nav-menu').isOpen()) {
                this.addNavOpenCssClassFromBody();
            } else {
                this.removeNavOpenCssClassFromBody();
            }
        }
        function close() {
            if ($mdSidenav('nav-menu').isOpen()) {
                this.removeNavOpenCssClassFromBody();
                $mdSidenav('nav-menu').toggle();
            }
        }

        function removeNavOpenCssClassFromBody() {
            const elem = angular.element($window.document.body);
            elem.removeClass('nav-menu__app--open');
        }

        function addNavOpenCssClassFromBody() {
            const elem = angular.element($window.document.body);
            elem.addClass('nav-menu__app--open');
        }

        function setNavMenuMarginOnElements(state) {
            const body = angular.element($window.document.body);
            removeNavMenuCssClasses(body);
            if (state === 'edit-store' || state === 'designer' || state === 'blocks') {
                body.addClass('nav-menu__small');
            } else if (state === 'volusion-payments') {
                body.addClass('nav-menu__none');
            } else {
                body.addClass('nav-menu__full');
            }
        }

        function removeNavMenuCssClasses(elem) {
            elem.removeClass('nav-menu__small');
            elem.removeClass('nav-menu__hidden');
            elem.removeClass('nav-menu__full');
            elem.removeClass('nav-menu__none');
        }

        function getSelectedAppType(pageType) {
            pageType = toLower(pageType);
            if (pageType.includes('order')) {
                return NAV_STATES.ORDERS;
            } else if (pageType.includes('product')) {
                return NAV_STATES.PRODUCTS;
            } else if (pageType.includes('categor')) {
                return NAV_STATES.CATEGORIES;
            } else if (pageType.includes('pages')) {
                return NAV_STATES.PAGES;
            } else if (pageType.includes('customer')) {
                return NAV_STATES.CUSTOMERS;
            } else if (pageType.includes('appstore')) {
                return NAV_STATES.APP_STORE;
            } else if (pageType.includes('settings.authorizenet')) {
                return NAV_STATES.VOLUSION_PAYMENTS;
            } else if (pageType.includes('settings')) {
                return NAV_STATES.SETTINGS;
            } else if (pageType.includes('editstore.menu')) {
                return NAV_STATES.EDIT_MENU;
            } else if (pageType.includes('editstore')) {
                return NAV_STATES.EDIT_STORE;
            } else if (pageType.includes('analytics')) {
                return NAV_STATES.ANALYTICS;
            } else if (pageType.includes('dashboard')) {
                return NAV_STATES.DASHBOARD;
            } else if (pageType.includes('myaccount')) {
                return NAV_STATES.MY_ACCOUNT;
            } else if (pageType.includes('users')) {
                return NAV_STATES.USER_PERMISSIONS;
            } else if (pageType.includes('blockmanagement')) {
                return NAV_STATES.BLOCK_MANAGEMENT;
            } else if (pageType.includes('designer')) {
                return NAV_STATES.SITE_DESIGNER;
            } else if (pageType.includes('sitetagging')) {
                return NAV_STATES.SITE_TAGGING;
            } else if (pageType.includes('menumanagement')) {
                return NAV_STATES.MENU_MANAGEMENT;
            }
        }

        function loadApps() {
            const apps = DEFAULT_APPS.filter(app => !app.hideInQuickMenu).sort((a, b) => {
                return appOrder.indexOf(a.type) - appOrder.indexOf(b.type);
            });

            return storeInformationService.getStore()
                .then(storeInformation => Promise.all([
                    launchDarklyService.isNewAccount(storeInformation),
                    launchDarklyService.getFeature('site-tagging-page'),
                    launchDarklyService.getFeature('users-and-permissions'),
                    launchDarklyService.getFeature('block-management'),
                    launchDarklyService.getFeature('element-menus'),
                    launchDarklyService.getFeature('new-admin-features-enabled')
                ]))
                .then(([
                    newAccount,
                    siteTaggingPage,
                    usersAndPermissions,
                    blockManagement,
                    elementMenus,
                    newAdminFeatures
                ]) => {
                    const categoryApp = apps.find(app => app.type === NAV_STATES.CATEGORIES);
                    categoryApp.link = 'categories.list';
                    const appList = [homeApp, ...apps];

                    if (siteTaggingPage) addNavItemAfterNavItemType(appList, siteTaggingApp, NAV_STATES.SITE_DESIGNER);

                    if (blockManagement) {
                        addNavItemAfterNavItemType(appList, blockManagementApp, NAV_STATES.ANALYTICS);
                    }

                    if (usersAndPermissions) {
                        addNavItemAfterNavItemType(appList, usersAndPermissionsApp, NAV_STATES.ANALYTICS);
                    }

                    if (elementMenus) {
                        addNavItemAfterNavItemType(appList, menuManagementApp, NAV_STATES.PAGES);
                        removeNavItemType(appList, NAV_STATES.EDIT_MENU);
                    }

                    if (newAccount) {
                        removeNavItemType(appList, NAV_STATES.PAGES);
                    }

                    if (newAdminFeatures.includes('storeCredit')) {
                        addNavItemAfterNavItemType(appList, storeCreditApp, NAV_STATES.PRODUCTS);
                    }

                    if (newAdminFeatures.includes('discounts')) {
                        addNavItemAfterNavItemType(appList, discountsApp, NAV_STATES.PRODUCTS);
                    }

                    if (newAdminFeatures.includes('orders')) {
                        mutateNavItemType(appList, NAV_STATES.ORDERS, {
                            href: `${process.env.NEW_ADMIN_BASE_URI}/orders/all`
                        });
                    }

                    return appList;
                }).catch((err) => {
                    // eslint-disable-next-line no-console
                    console.error(`Problem getting LaunchDarkly flags: ${err.message}`);
                    return [homeApp, ...apps];
                });
        }

        function addNavItemAfterNavItemType(appList, navMenuItemToAdd, navMenuTypeToAddAfter) {
            const navItemIndex = findIndex(appList, { type: navMenuTypeToAddAfter });
            appList.splice(navItemIndex + 1, 0, navMenuItemToAdd);
        }

        function mutateNavItemType(appList, navMenuTypeToMutate, newMenuItemAttrs) {
            appList.forEach((app, i) => {
                if (app.type === navMenuTypeToMutate) {
                    appList[i] = { ...app, ...newMenuItemAttrs };
                }
            });
        }

        function removeNavItemType(appList, navMenuTypeToRemove) {
            const navItemIndex = findIndex(appList, { type: navMenuTypeToRemove });
            appList.splice(navItemIndex, 1);
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/navigationMenu/services/navigationMenu.service.js